import React from 'react';
import Heading from '@atlaskit/heading';

import { type Organisation } from '../../../types';
import { useIsSwitcherTeam25TestCohort } from '../experiment-provider';

const CurrentOrganisation = (props: Organisation) => {
	const isVisualRefreshEnabled = useIsSwitcherTeam25TestCohort();

	return (
		<Heading as="h2" size={isVisualRefreshEnabled ? 'small' : 'medium'}>
			{props.displayName}
		</Heading>
	);
};

export default CurrentOrganisation;
